export default __webpack_public_path__ + "static/media/parcours_1_senait_bateau_penumatique.e2c9da38.png";